import TWalkthroughBusinessHoursDateTime from './index.vue';

TWalkthroughBusinessHoursDateTime.install = app => {
  app.component(TWalkthroughBusinessHoursDateTime.name, TWalkthroughBusinessHoursDateTime);
};

export default TWalkthroughBusinessHoursDateTime;
